import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import * as onboarding from '../../Onboarding/redux/store'
import * as events from '../../../store/events'
import * as pdp from '../../../store/productDetailPage'

import {clearOnSuccess} from '../../Onboarding/redux/actions'
import {closePartyAvailableModal} from '../../../actions/productDetailPage'

const PartyAvailableModalCta = ({
  callBack,
  clearOnSuccessCallback,
  closeModal,
  eventId,
  onSuccess,
}) => (
  <div className="modal-cta-wrapper">
    <button className="modal-cta-nevermind" onClick={closeModal}>
      <span>Nevermind</span>
    </button>
    <button
      className="modal-cta-reserve"
      onClick={() => {
        closeModal()
        if (onSuccess) {
          onSuccess(eventId)
          clearOnSuccessCallback() // Needed so it doesn't interfere with pdp onSuccess callback()
        } else {
          callBack()
        }
      }}
    >
      <span>Reserve for myself</span>
    </button>
  </div>
)

PartyAvailableModalCta.defaultProps = {
  onSuccess: null,
  callBack: null,
}

PartyAvailableModalCta.propTypes = {
  callBack: PropTypes.func,
  clearOnSuccessCallback: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  eventId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func,
}
const mapStateToProps = (state) => ({
  callBack: pdp.callBack(state),
  eventId: events.currentId(state),
  onSuccess: onboarding.onSuccess(state),
})

const mapDispatchToProps = (dispatch) => ({
  clearOnSuccessCallback: () => dispatch(clearOnSuccess()),
  closeModal: () => dispatch(closePartyAvailableModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(PartyAvailableModalCta)
